export const SET_AUTH = "SET_AUTH";
export const SET_JWT = "SET_JWT";
export const SET_USERNAME = "SET_USERNAME";
export const SET_USERROLE = "SET_USERROLE";
